(() => {
  const isClickDummy = (
    window.swinger.config
    && window.swinger.config.isClickDummy
  );

  const { apiBase } = window.swinger.config;

  const api = {
    me: window.swinger.api.me,
    setItemLikeState(type, identifier, liked) {
      return window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.like}`, {
        method: 'POST',
        body: JSON.stringify({
          type,
          identifier,
          liked,
        }, null, 4),
      });
    },
    setDisplayMode(displayMode) {
      return window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.me}`, {
        method: 'POST',
        body: JSON.stringify({
          preferences: {
            displayMode,
          },
        }, null, 4),
      });
    },
    trackLastSeen(type, identifier) {
      let alreadyTracked = false;
      const track = (resolve, reject) => {
        if (alreadyTracked) {
          return;
        }
        alreadyTracked = true;

        window.swinger.ajax(`${apiBase}${window.swinger.config.apiRoutes.lastSeen}`, {
          method: 'POST',
          body: JSON.stringify({
            type,
            identifier,
          }, null, 4),
        }).then(resolve).catch(reject);
      };

      return new Promise((resolve, reject) => {
        if (document.visibilityState === 'visible') {
          track(resolve, reject);
          return;
        }

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            track(resolve, reject);
          }
        });
      });
    },
  };

  if (isClickDummy) {
    Object.keys(api).forEach((key) => {
      if (key === 'me') {
        return;
      }

      api[key] = (...args) => {
        window.console.log(args);
        return new Promise((resolve) => {
          window.setTimeout(() => {
            resolve({});
          }, 5000);
        });
      };
    });
  }

  window.swinger = window.swinger || {};
  window.swinger.api = { ...window.swinger.api, ...api };
})();
